module.exports = __webpack_public_path__ + "static/media/cantact us 2.6639b285.png";